import React, { useState } from 'react';
import { observer } from 'mobx-react';
import clsx from 'clsx';
import BasketballMatchGameBoxScore from './boxScore';
import BasketballMatchGameSpecial from './special';
import MatchTracker from '../../../shared/matchTracker';
import SportsTeamLogo from '../../../../../components/teamLogo';
import BetBleLink from '../../../match/component/BetBleLink';
import {getStreamBrowser} from "../../../liveStream/util";

const BasketballMatchGame = observer(({ item }) => {
  const {
    getTeamData,
    getMatchGameTime,
    winnerTeam,
    statusText,
    matchTrackerVisible,
    betbleButtonVisible,
    displayTime,
    getTracker,
    betbleUri,
    availableBroadcast,
    gameStatus,
    teamFoul
  } = item;
  const { playText, teamName } = availableBroadcast;
  const [selectedTab, setSelectedTab] = useState('score');

  const onClickDetailTab = (type) => {
    setSelectedTab(type);
  };

  const handleClickBetbleLink = (event) => {
    event.stopPropagation();
    let type = 0;

    if (item.getTracker.status === 'progress') {
      type = 1;
    }
    const url = `https://betble.com/game/game.php?type=${type}${betbleUri}`;
    window.open(url);
  };
  const onClickVideo = () => {
    getStreamBrowser(item.videoLink);
  };

  return (
    <div className="score_detail_board basketball">
      {/* summary_score */}
      <div className="summary_score">
        <div className="team left">
          <SportsTeamLogo
            className="logo"
            imgSize={33}
            imgUrl={getTeamData.home.imgPath}
            isLazy={false}
            location="home"
          />
          <span className="name">{getTeamData.home.name}</span>
          {gameStatus === 'IN_PROGRESS' && (
            <div className="foul">
              <em className={clsx(teamFoul.home >= 1 && 'active')} />
              <em className={clsx(teamFoul.home >= 2 && 'active')} />
              <em className={clsx(teamFoul.home >= 3 && 'active')} />
              <em className={clsx(teamFoul.home >= 4 && 'active')} />
              <em className={clsx(teamFoul.home >= 5 && 'active')} />
            </div>
          )}
        </div>
        <div className="info">
          <div className="score">
            <strong
              className={clsx(
                'left',
                winnerTeam.activeScore === 'home' && 'on'
              )}
            >
              <em className="num">{getTeamData.home.score}</em>
            </strong>
            <div className="state">
              {getTracker.status === 'progress' && (
                <span>{`${statusText} ${displayTime}`}</span>
              )}
              {getTracker.status === 'final' && <span>{statusText}</span>}
            </div>
            <strong
              className={clsx(
                'right',
                winnerTeam.activeScore === 'away' && 'on'
              )}
            >
              <em className="num">{getTeamData.away.score}</em>
            </strong>
          </div>
          <div className="time">{getMatchGameTime}</div>
          {!!item.videoLink &&  ( gameStatus === "IN_PROGRESS" || gameStatus === "BREAK_TIME" || gameStatus === "PAUSE" ) && (
              <div className="video">
                <a target="_blank" onClick={onClickVideo} className="tag">생중계</a>
              </div>
          )}
          <div className="play_text">{`${teamName} ${playText}`}</div>
        </div>
        <div className="team right">
          <SportsTeamLogo
            className="logo"
            imgSize={33}
            imgUrl={getTeamData.away.imgPath}
            isLazy={false}
            location="away"
          />
          <div className="name">{getTeamData.away.name}</div>
          {gameStatus === 'IN_PROGRESS' && (
            <div className="foul">
              <em className={clsx(teamFoul.away >= 1 && 'active')} />
              <em className={clsx(teamFoul.away >= 2 && 'active')} />
              <em className={clsx(teamFoul.away >= 3 && 'active')} />
              <em className={clsx(teamFoul.away >= 4 && 'active')} />
              <em className={clsx(teamFoul.away >= 5 && 'active')} />
            </div>
          )}
        </div>
        {betbleButtonVisible && (
          <BetBleLink clickHandler={handleClickBetbleLink} />
        )}
      </div>
      {/* // summary_score */}
      {/* detail_score */}
      <div className="detail_score">
        <ul className="tab">
          <li>
            <button
              className={clsx(selectedTab === 'score' && 'selected')}
              onClick={() => onClickDetailTab('score')}
            >
              스코어
            </button>
          </li>
          <li>
            <button
              className={clsx(selectedTab === 'special' && 'selected')}
              onClick={() => onClickDetailTab('special')}
            >
              스페셜
            </button>
          </li>
          {matchTrackerVisible && (
            <li>
              <button
                className={clsx(selectedTab === 'matchTracker' && 'selected')}
                onClick={() => onClickDetailTab('matchTracker')}
              >
                상황중계
              </button>
            </li>
          )}
        </ul>

        {selectedTab === 'matchTracker' && <MatchTracker item={item} />}

        {selectedTab !== 'matchTracker' && (
          <div className="detail_board">
            <div className="team">
              <span>{getTeamData.away.name}</span>
              <span>{getTeamData.home.name}</span>
            </div>

            {selectedTab === 'score' ? (
              <BasketballMatchGameBoxScore item={item} />
            ) : (
              <BasketballMatchGameSpecial item={item} />
            )}
          </div>
        )}
      </div>
      {/* // detail_score */}
    </div>
  );
});

export default BasketballMatchGame;
